class drop_down_gs extends drop_down {

    constructor(select_id, template) {
        super(select_id, template);
        this.select_id = select_id;
        this.fill_select();
    }


    fill_select() {
        var select = this.get_select(), class_list;
        select[0].options.length = 0;
        for (var i = 0; i < gs_data.length; i++) {
            class_list = [];
            select.append('<option data-i="' + i + '" class="' + class_list.join(' ') + '" value="' + gs_data[i].description + '">' + gs_data[i].title + '</option>');
        }
    }

    get_li_data(option_index) {
        var gs = gs_data[option_index];
        var classes = [];

        var specs = '<div class="product-spec metric"><span class="spec-label">' + texts.refine_roddia_text + '<span class=\'diameter\'>&nbsp;&#8960;</span>:</span><span class="spec-value">' + gs.stangdia + '&nbsp;mm</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_roddia_text + '<span class=\'diameter\'>&nbsp;&#8960;</span>:</span><span class="spec-value">' + mm_to_inch(gs.stangdia) + '"</span></div>';
        specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_housedia_text + '<span class=\'diameter\'>&nbsp;&#8960;</span>:</span><span class="spec-value">' + gs.huisdia + '&nbsp;mm</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_housedia_text + '<span class=\'diameter\'>&nbsp;&#8960;</span>:</span><span class="spec-value">' + mm_to_inch(gs.huisdia) + '"</span></div>';
        specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_stroke_text + '</span><span class="spec-value">' + gs.slag + '&nbsp;mm</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_stroke_text + '</span><span class="spec-value">' + mm_to_inch(gs.slag) + '"</span></div>';
        specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_length_text + '</span><span class="spec-value">' + gs.lengte + '&nbsp;mm</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_length_text + '</span><span class="spec-value">' + mm_to_inch(gs.lengte) + '"</span></div>';
        specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_thread_text + '</span><span class="spec-value">M' + gs.dschroefdraad + '</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_thread_text + '</span><span class="spec-value">M' + gs.dschroefdraad + '</span></div>';

        var price = config_price_ex ? gs.price_ex : gs.price;
        specs += '<div class="product-spec metric"><span class="spec-label-price">' + texts.refine_price + '</span><span class="spec-value-price">' + cf.format_price(price) + '</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label-price">' + texts.refine_price + '</span><span class="spec-value-price">' + cf.format_price(price) + '</span></div>';

        let cadpic = gs.png;
        let gs_buttons = '';
        if (cadpic) {
            gs_buttons = '<button type="button" class="show_2d_cad_dd" data-cadpic="' + cadpic + ',' + this.select_id + '"></button>';
        }

        var price = config_price_ex ? gs.price_ex : gs.price;

        return {
            picture_src: gs.dropdown_img_src,
            title: gs.title,
            price: cf.format_price(price),
            specs: specs,
            sku: texts.refine_sku_text + ' ' + gs.sku,
            stock: this.format_stock(gs, texts),
            id: this.select_id + '_' + option_index,
            classes: classes,
            button2dgs: gs_buttons
        };

    }

    update_visibility() {
        var show = true, gs;
        this.showing = [];

        for (var i = 0; i < gs_data.length; i++) {
            show = true;
            gs = gs_data[i];

            if (gs.aanconfig !== '1') {
                show = false;
            }

            if (gs.materiaal !== $("#material").val()) {
                show = false;
            }
            if (gs.type !== $("#type").val()) {
                show = false;
            }
            var wished_force = fd.get().gasspring_wished_force * 1;
            if (wished_force) {
                if (!(wished_force >= (gs.min_force * 1) && wished_force <= (gs.max_force * 1))) {
                    show = false;
                }
            }

            var max_nr_gss = 5;
            var index_found = -1;
            if (cf.as.sorted_length_combis.length
                && (fd.get().mp_rod_type !== 'none' || fd.get().mp_cyl_type !== 'none')
                && (fd.get().gasspring_wished_force !== "" || fd.get().gasspring_total_length !== "")
            ) {
                index_found = cf.as.gs_desc_list.indexOf(gs.description);
                if (index_found > (max_nr_gss - 1) || index_found === -1) {
                    show = false;
                }
            }

            if (show) {
                $("#gasspring").find("[data-i='" + i + "']").removeClass('hidden');
                this.showing.push(gs);
            } else {
                $("#gasspring").find("[data-i='" + i + "']").addClass('hidden');
            }
        }

        if ($('#gasspring :selected').hasClass('hidden')) {
            var gasspring_value = this.showing[0].description;
            $('#gasspring').val(gasspring_value).change();
        }

        if (typeof (this.html_select) !== 'undefined') {
            this.html_select.sync();
        }

    }

}
